import { useState, useEffect } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_CONFIG_COMPLETED } from '../constants/events.js';
function useWalletCalcConfig(payments, listing) {
  let buildConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const [config, setConfig] = useState({});
  const updateConfiguration = data => {
    setConfig(data);
  };
  useEffect(() => {
    eventBus.on(UDS_CONFIG_COMPLETED, updateConfiguration);
    return () => {
      eventBus.off(UDS_CONFIG_COMPLETED, updateConfiguration);
    };
  }, [payments, listing, buildConfig]);
  return config;
}
export { useWalletCalcConfig as default };
